import React from 'react';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import ActionVisible from 'material-ui/svg-icons/action/visibility';
import ActionVisibleOff from 'material-ui/svg-icons/action/visibility-off';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import CheckboxIcon from 'material-ui/svg-icons/toggle/check-box';
import CheckboxOutlineIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import { Checkbox, SelectField, TextField } from 'material-ui';
import SuperSelectField from 'material-ui-superselectfield';

export const renderFavoriteCheckbox = ({ input, label, ...custom }) => (
    <Checkbox
        style={custom.style}
        checkedIcon={<ActionFavorite />}
        uncheckedIcon={<ActionFavoriteBorder />}
        label={label}
        checked={!!input.value}
        onCheck={input.onChange}
        {...input}
        {...custom}
    />
);

export const renderVisibleCheckBox = ({ input, label, ...custom }) => (
    <Checkbox
        style={custom.style}
        checkedIcon={<ActionVisible/>}
        uncheckedIcon={<ActionVisibleOff/>}
        label={label}
        checked={!!input.value}
        onCheck={input.onChange}
        {...input}
        {...custom}
    />
);

export const renderCheckbox = ({ input, label, ...custom }) => (
    <Checkbox
        style={custom.style}
        checkedIcon={<CheckboxIcon />}
        uncheckedIcon={<CheckboxOutlineIcon />}
        label={label}
        checked={!!input.value}
        onCheck={input.onChange}
        {...input}
        {...custom}
    />
);

export const renderSuperSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => (
    <SuperSelectField
        floatingLabel={label}
        hintText={label}
        onChange={(event, index, value) => input.onChange(value)}
        onBlur={() => input.onBlur(input.value)}
        showAutocompleteThreshold={0}
        elementHeight={43}
        checkPosition="right"
        multiple
        children={children}
        {...input}
        {...custom}
    />
);

export const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <TextField
        hintText={label}
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}
    />
);
export const renderNumberField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <TextField
        onBlur={() => {}}
        hintText={label}
        type="number"
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}
    />
);

export const render = ({ input, label, meta: { touched, error }, ...custom }) => (
    <TextField
        hintText={label}
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}
    />
);

export const renderPasswordField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <TextField
        hintText={label}
        type="password"
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}
    />
);

export const renderSelectField = ({ input, label, meta: { touched, error }, children, onCustomChange, ...custom }) => (
    <SelectField
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}
        onChange={(event, index, value) => {
            input.onChange(value);
            if (onCustomChange) {
                onCustomChange(value);
            }
        }}
        children={children}
    />
);



// WEBPACK FOOTER //
// src/services/form.js